export default __webpack_public_path__ + "static/media/saveBtnSquare.8089d63f.svg";